import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=04005d4c&scoped=true&"
import script from "./AddClass.vue?vue&type=script&lang=ts&"
export * from "./AddClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04005d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04005d4c')) {
      api.createRecord('04005d4c', component.options)
    } else {
      api.reload('04005d4c', component.options)
    }
    module.hot.accept("./AddClass.vue?vue&type=template&id=04005d4c&scoped=true&", function () {
      api.rerender('04005d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classes/AddClass.vue"
export default component.exports